(function($) {
	"use strict";
    var clOffCanvas = function() {

        var menuTrigger     = $('.header-nav-toggle'),
            nav             = $('.header-nav'),
            closeButton     = nav.find('.nav-close'),
            siteBody        = $('body');

        // open-close menu by clicking on the menu icon
        menuTrigger.on('click', function(e){
            e.preventDefault();
            siteBody.toggleClass('open-menu');
        });

        // close menu by clicking the close button
        closeButton.on('click', function(e){
            e.preventDefault();
            menuTrigger.trigger('click');
        });

        // close menu clicking outside the menu itself
        siteBody.on('click', function(e){
            if( !$(e.target).is('.header-nav, .nav-content, .header-nav-toggle, .header-nav-toggle span') ) {
                siteBody.removeClass('open-menu');
            }
        });

    };
    (function clInit() {
        clOffCanvas();
    })();        
})(jQuery);